module.exports = __webpack_public_path__ + "8866c53fdde279c8dbde861e54c0d73c.woff2";